import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, Stack } from '@mui/material';

import { NavBar } from '~components/atoms';
import { FORGOT_PASSWORD_PATH } from '~configs';

export const LoginLayout: React.FC = () => {
  const location = useLocation();
  const enableBackToLoginPage = location.pathname === FORGOT_PASSWORD_PATH;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100vw',
        height: '100vh',
        margin: 'auto',
      }}
    >
      {/* Navbar */}
      <NavBar
        LeftComponent={enableBackToLoginPage ? undefined : null}
        RightComponent={null}
      />

      {/* Outlet display */}
      <Stack
        overflow={'auto'}
        sx={{
          justifyContent: 'space-between',
          flex: 1,
          marginTop: '64px',
        }}
      >
        <Outlet />
      </Stack>
    </Box>
  );
};
